import { Form, LabelProps, SemanticWIDTHS } from '@servicetitan/design-system';
import { InputFieldState } from '@servicetitan/form';
import { observer } from 'mobx-react';
import {
    ChangeEvent,
    FC,
    InputHTMLAttributes,
    KeyboardEventHandler,
    ReactElement,
    ReactNode,
} from 'react';
import ReactInputMask from 'react-input-mask';

export interface MaskedInputProps {
    placeholder: string;
    fieldState: InputFieldState<string>;
    error?: string | boolean;
    disabled?: boolean;
    label?: ReactNode;
    labelProps?: LabelProps;
    description?: ReactElement | string;
    mask: string;
    className?: string;
    width?: SemanticWIDTHS | string | number;
    onInputBlur?: () => void;
    validator?: (value: string) => Promise<void> | void;
    small?: boolean;
    onKeyPress?: KeyboardEventHandler<HTMLInputElement | undefined>;
}
export type ChildInputProps = InputHTMLAttributes<HTMLInputElement> & MaskedInputProps;

export const MaskedPhoneInput: FC<MaskedInputProps> = observer(({ onInputBlur, ...props }) => {
    const inputOnChangeHandler = async (e: ChangeEvent<HTMLInputElement>) => {
        props.fieldState.onChangeHandler(e, {
            value: (e.target.value || '').replace(/[^0-9.]/g, ''),
        });
        await props.validator?.(props.fieldState.value);
    };

    return (
        <ReactInputMask
            value={props.fieldState.value}
            onChange={inputOnChangeHandler}
            onBlur={onInputBlur}
            data-cy="masked-input"
            {...props}
        >
            {(childProps: ChildInputProps) => (
                <Form.Input disabled={props.disabled} {...childProps} />
            )}
        </ReactInputMask>
    );
});
